import React from 'react';
import { Image, Font, Link, Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';
import logo from "../../image/logohorizontal.png"

// Create styles
const styles = StyleSheet.create({
    table: {
        marginTop: "0px",
        display: "flex",
        flexDirection: "column",
    },
    row: {
        display: "flex",
        flexDirection: "row",
    },
    cell: {
        padding: 5,
        textAlign: "center",
        fontSize: "11px",
        height: "auto"
    },
    header: {
        backgroundColor: "#094b88",
        fontWeight: 700,
        color: "white",
        minHeight: "30px",
        fontSize: "12px",
        textAlign: "center",
        paddingTop: "5px",
        paddingBottom: "5px",
    },
    header2: {
        backgroundColor: "#094b88",
        fontWeight: 700,
        color: "white",
        minHeight: "30px",
        fontSize: "12px",
        textAlign: "center",
        paddingTop: "5px",
        paddingBottom: "5px",
    },
    cantidad: {
        width: "40px",
        textAlign: "center"
    },
    desc: {
        width: "60px",
        marginRight: "10px",
        textAlign: "center"
    },
    descripcion: {
        width: "40%",
        textAlign: "left",
    },
    flexibleCell: {
        flex: 1
    },
    info: {
        fontSize: "9px",
        color: "gray"
    },
    page: {
        flexDirection: 'column',
        justifyContent: 'flex-start',
        backgroundColor: '#fff',
        minHeight: '100vh',
        minWidth: '100vw',
        padding: "30px",
        paddingBottom: "45px"
    },
    section: {
        marginTop: 5,
        marginBottom: 5,
        paddingBottom: 5,
        paddingTop: 5,
        fontSize: 12,
    },
    nocotizacion: {
        color: "red",
    },
    adorno: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "50px",
        width: "100px",
        overflow: "hidden"
    },
    minadorno: {
        display: "block",
        width: "100px",
        height: "12px",
        borderRadius: "10px",
        backgroundColor: "#8c9cbb",
        marginLeft: "-15px"
    },
    minadorno2: {
        display: "block",
        width: "100px",
        height: "12px",
        borderRadius: "10px",
        backgroundColor: "#619bd8",
        marginLeft: "-15px"
    },
    titulo: {
        color: "#094b88",
        fontWeight: 700,
        fontSize: "20px",
        marginTop: "15px",
        paddingBottom: "5px",
        marginBottom: "10px",
        // borderBottomColor: "#95b5ab",
        // borderBottomStyle: "solid",
        // borderBottomWidth: "2px",
    },
    titulo2: {
        color: "#094b88",
        fontWeight: 700,
        fontSize: "20px",
        marginTop: "15px",
        paddingBottom: "5px",
        marginBottom: "10px",
        // borderBottomColor: "#95b5ab",
        // borderBottomStyle: "solid",
        // borderBottomWidth: "2px",
    },
    divider: {
        height: "5px",
        width: "100%",
        marginTop: "5px",
        marginBottom: "5px",
        borderBottomColor: "#094b88",
        borderBottomStyle: "solid",
        borderBottomWidth: "2px",
    },
    divider2: {
        height: "5px",
        width: "100%",
        marginTop: "5px",
        marginBottom: "5px",
        borderBottomColor: "#094b88",
        borderBottomStyle: "solid",
        borderBottomWidth: "2px",
    },
    footer: {
        position: "absolute",
        bottom: 30,
        right: 30,
        textAlign: "center",
        fontSize: 12,
    },
    totalBox: {
        width: "60%",
        marginLeft: "40%",
        marginTop: "20px",
        fontSize: "14px",
    },

    txtViewTotal: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        width: "100%",
        borderBottomColor: "#094b88",
        borderBottomWidth: "1px",
        marginBottom: "10px"
    },
    txtViewTotal2: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        width: "100%",
        borderBottomColor: "#619bd8",
        borderBottomWidth: "1px",
        marginBottom: "10px"
    },
    totaltexttitle: {
        fontSize: "15px"
    },
    separadorTitulo: {
        fontSize: "12px",
        fontWeight: "bold",
        margin: "5px 0"
    },


});

const hyphenationCallback = (word) => {
    return word.replace(/([aeiouy])(?=[^aeiouy])/gi, '$1-').split('-');
};

Font.registerHyphenationCallback(hyphenationCallback);

// Create Document Component
export const ReactPdfDocument = (params) => {
    let convertir = require('numero-a-letras');

    let base = {};

    if (params.base) {
        base = params.base
    }
    // const parseStringToFloat = (str) => {
    //     // Reemplazar las comas (,) por nada y convertir el string a número flotante
    //     return parseFloat(str.replace(/,/g, ''));
    // };

    function capitalizeWords(str) { return str.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' '); }
    // console.log(base)

    // Suma de porcentaje
    const porcentplus = (part, total) => {
        // console.log(part);
        // console.log(total);

        return total + ((part * total) / 100)
    }

    const formatNumber = (num) =>
        num.toLocaleString("en-US", {
            minimumFractionDigits: 2, // Al menos 2 decimales
            maximumFractionDigits: 2, // Máximo 2 decimales
            useGrouping: true,       // Usar separación de miles
        });

    // Calcula el ISR
    const handleISR = (element) => {
        return (parseFloat(esString(element) ? element.replace(/[^0-9.-]+/g, "") : element) * 0.015).toFixed(2)
    }

    // Calcula el IVA
    const handleIVA = (element) => {
        return (parseFloat(esString(element) ? element.replace(/[^0-9.-]+/g, "") : element) * 0.16).toFixed(2)
    }

    function esString(variable) {
        return Object.prototype.toString.call(variable) === "[object String]";
    }

    return (
        <Document
            fileName='Hola'
            title='Cotizacion A House Interior'
            author='Norma Lydia Aldana Gomez'
            subject='Cotizacion'
            keywords='Cotizacion'
            creator='Abdiel Aldana'
            producer='Aurora Amethyst'
            pdfVersion="1.0"
            language='es-MX'
            pageMode='fullScreen'
            pageLayout='singlePage'
        >
            <Page size="A4" style={styles.page} wrap
                orientation='portrait'>

                <View fixed style={[styles.section, { display: "flex", flexDirection: "row", justifyContent: "space-evenly", alignItems: "center" }]}>

                    {params.tipo == "2" ?
                        <View
                            style={styles.adorno}
                        >
                            <Link style={styles.minadorno2}>a</Link>
                            <Link style={styles.minadorno2}>a</Link>
                            <Link style={styles.minadorno2}>a</Link>
                        </View>
                        :
                        <View
                            style={styles.adorno}
                        >
                            <Link style={styles.minadorno}>a</Link>
                            <Link style={styles.minadorno}>a</Link>
                            <Link style={styles.minadorno}>a</Link>
                        </View>
                    }
                    <Image
                        cache
                        src={logo}
                        style={{ height: '40px', width: 'auto', margin: "0 auto" }}
                    />
                    <View style={{ textAlign: "right" }}>
                        <View style={{ width: "100px", textAlign: "center", display: "flex", justifyContent: "flex-end" }}>
                            <Text style={{ textAlign: "right" }}>No.<Text style={styles.nocotizacion}> {base.ot}  </Text></Text>
                        </View>
                        <View style={{ width: "100px", textAlign: "right", display: "flex", justifyContent: "flex-end" }}>
                            <Text style={{ textAlign: "right" }}>Fecha: <Text>{base.fecha}  </Text></Text>
                        </View>
                    </View>
                </View>

                <View style={{ textAlign: 'center' }}>
                    <Text style={styles.titulo2}>PRESUPUESTO</Text>
                </View>

                <View style={styles.divider}></View>

                <View style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "flex-end" }}>
                    <View style={{ width: "70%", textAlign: "left" }}>
                        <Text style={{ fontSize: "10px", fontWeight: 700 }}>Cliente:</Text>
                        <Text style={{ color: "#094b88", fontSize: "14px" }}>{base.compania.nombre}</Text>
                        {/* <Text style={{ fontSize: "12px" }}>{capitalizeWords(base.datosCliente.direccion)}</Text> */}

                    </View>
                    <View style={{ width: "30%", textAlign: "right" }}>
                        <Text>OT {base.ot_externo}</Text>
                        {/* {params.tipo == "2" && <Text style={{ color: params.tipo == "2" ? "#094b88" : "#4e8373", fontSize: "14px" }}>Distribuidor</Text>} */}
                    </View>
                </View>

                <View style={styles.divider}></View>

                <View style={{ display: "flex", flexDirection: "row", alignItems: "center", margin: "20px 0" }}>
                    <View style={{ width: "5cm", height: "5cm", overflow: "hidden" }}>
                        <Image
                            cache
                            src={"https://apiclimas.abdielaldana.com/" + base.vehiculo.ruta}
                            style={{ height: '100%', width: '100%', objectFit: "cover" }}
                        />
                    </View>
                    <View style={{ width: "70%", textAlign: "left", marginLeft: "25px" }}>
                        <View>
                            <Text style={{ fontSize: "12px" }}>Información del Vehiculo</Text>
                            <View style={styles.divider}></View>
                            <View>
                                <Text style={{ color: "#094b88", fontSize: "14px" }}>{base.vehiculo.marca + ' ' + base.vehiculo.modelo}</Text>
                                <Text style={{ fontSize: '14px' }}>Color: {base.vehiculo.color}</Text>
                                <Text style={{ fontSize: '14px' }}>Placas: {base.vehiculo.placas}</Text>
                                <Text style={{ fontSize: '14px' }}>Kilometraje: {base.vehiculo.kilometraje}km</Text>
                                <Text style={{ fontSize: '14px' }}>VIN: {base.vehiculo.vin}</Text>
                            </View>
                        </View>

                    </View>
                </View>

                <View style={styles.table}>
                    {/* Fila de encabezado */}

                    <View style={[styles.row, styles.header]} fixed>
                        <Text style={[styles.cell, styles.cantidad]}>Cnt.</Text>
                        <Text style={[styles.cell, styles.descripcion]}>Descripcion</Text>
                        <Text style={[styles.cell, styles.flexibleCell]}>Precio Unitario</Text>
                        <Text style={[styles.cell, styles.flexibleCell]}>Total</Text>
                    </View>


                    {/* Fila de datos */}
                    {base.conceptos.map((row, index) => {



                        return (
                            <React.Fragment key={index}>
                                <View wrap={false} style={[styles.row, { borderBottomWidth: "1px", borderBottomColor: "gray", break: 'avoid', }]}>
                                    <Text style={[styles.cell, styles.cantidad]}>{row.cantidad}</Text>
                                    <View style={[styles.cell, styles.descripcion]}>
                                        <Text style={{ color: "#094b88" }}>{capitalizeWords(row.concepto)}</Text>
                                    </View>

                                    <View style={[styles.cell, styles.flexibleCell]}>
                                        <Text>${row.precio_unitario}</Text>
                                    </View>
                                    <View style={[styles.cell, styles.flexibleCell]}>
                                        <Text>${row.total}</Text>
                                    </View>

                                </View>
                            </React.Fragment>
                        )


                    })}
                </View>

                <View wrap={false} style={styles.totalBox}>
                    <View>

                        {/* SubTotal */}

                        <View style={[params.tipo == "2" ? styles.txtViewTotal2 : styles.txtViewTotal, styles.totaltexttitle]}>
                            <Text>Subtotal:</Text>
                            <Text>${base.precio}</Text>
                        </View>


                        {/* IVA */}
                        {/* {(params.tipo == "1" && (base.opciones.tipoFactura == "iva" || base.opciones.tipoFactura == "isr")) &&
                            <View style={[params.tipo == "2" ? styles.txtViewTotal2 : styles.txtViewTotal, styles.totaltexttitle]}>
                                <Text>IVA:</Text>
                                <Text>+16%</Text>
                                <Text>{formatNumber(parseStringToFloat(base.totales.subtotal1) * 0.16)}</Text>
                            </View>
                        } */}


                        {/* TOTAL */}

                        <View style={[styles.txtViewTotal, styles.totaltexttitle]}>
                            <Text>Total:</Text>
                            <Text>${base.precio}</Text>
                        </View>



                        {/* TOTAL EN LETRAS */}

                        <View>
                            {/* <Text style={{ fontSize: "9px", color: "gray", textAlign: "center" }}>{convertir.NumerosALetras(parseStringToFloat(base.totales.total) - 80000 )}</Text> */}
                            <Text style={{ fontSize: "9px", color: "gray", textAlign: "center" }}>{convertir.NumerosALetras(base.precio)}</Text>
                        </View>


                    </View>

                </View>

                {base.imagenes.length > 0 &&
                    <View break>
                        <View fixed style={{ textAlign: 'center' }}>
                            <Text style={styles.titulo2}>Evidencias</Text>
                        </View>
                        <View fixed style={styles.divider}></View>

                        {/* Fila de Evidencias */}
                        <View style={{ display: "flex", flexDirection: "row", alignItems: "center", margin: "10px 0", flexWrap: "wrap" }}>
                            {base.imagenes.map((row, index) => {
                                return (
                                    <React.Fragment key={index}>
                                        <View wrap={false} style={{ display: "flex", flexDirection: "row", margin: "10px 0", width: "100%" }}>
                                            <View style={{ width: "5cm", height: "5cm", overflow: "hidden", marginBottom: "5px" }}>
                                                <Link src={"https://apiclimas.abdielaldana.com/" + row.ruta}>
                                                    <Image
                                                        cache
                                                        src={"https://apiclimas.abdielaldana.com/" + row.ruta}
                                                        style={{ height: '100%', width: '100%', objectFit: "cover" }}
                                                    />
                                                </Link>
                                            </View>
                                            <View style={{ width: "70%", textAlign: "left", marginLeft: "25px" }}>
                                                <View>
                                                    <Text style={{ color: "#094b88", fontSize: "13px" }}>Evidencia {index + 1}</Text>
                                                    <View style={styles.divider}></View>
                                                    <View>
                                                        <Text style={{ fontSize: '12px' }}>{row.descripcion}</Text>
                                                    </View>
                                                </View>

                                            </View>
                                        </View>
                                    </React.Fragment>
                                )
                            })}
                        </View>
                    </View>
                }

                {base.comparativas.length > 0 &&
                    <View break>
                        <View fixed style={{ textAlign: 'center' }}>
                            <Text style={styles.titulo2}>Comparativas</Text>
                        </View>
                        <View fixed style={styles.divider}></View>

                        {/* Fila de Evidencias */}
                        <View style={{ display: "flex", flexDirection: "row", alignItems: "center", margin: "10px 0", flexWrap: "wrap" }}>
                            {base.comparativas.map((row, index) => {
                                return (
                                    <React.Fragment key={index}>
                                        <View wrap={false}>
                                            <Text style={{ color: "#094b88", fontSize: "13px" }}>Comparativa {index + 1}</Text>
                                            <View style={styles.divider}></View>
                                            <View style={{ display: "flex", flexDirection: "row", margin: "10px 0", width: "100%" }}>
                                                <View style={{ display: "flex", flexDirection: "column", alignItems: 'center', margin: "10px 0", width: "50%" }}>
                                                    <View style={{ width: "5cm", height: "5cm", overflow: "hidden", marginBottom: "5px" }}>
                                                        <Link src={"https://apiclimas.abdielaldana.com/" + row.ruta_antes}>
                                                            <Image
                                                                cache
                                                                src={"https://apiclimas.abdielaldana.com/" + row.ruta_antes}
                                                                style={{ height: '100%', width: '100%', objectFit: "cover" }}
                                                            />
                                                        </Link>
                                                    </View>
                                                    <View style={{ width: "70%", textAlign: "left", marginLeft: "25px" }}>
                                                        <View>
                                                            <Text style={{ color: "#094b88", fontSize: "13px" }}>Antes</Text>
                                                            <View style={styles.divider}></View>
                                                            <View>
                                                                <Text style={{ fontSize: '12px' }}>{row.descripcion_antes}</Text>
                                                            </View>
                                                        </View>

                                                    </View>
                                                </View>
                                                <View style={{ display: "flex", flexDirection: "column", alignItems: 'center', margin: "10px 0", width: "50%" }}>
                                                    <View style={{ width: "5cm", height: "5cm", overflow: "hidden", marginBottom: "5px" }}>
                                                        <Link src={"https://apiclimas.abdielaldana.com/" + row.ruta_despues}>
                                                            <Image
                                                                cache
                                                                src={"https://apiclimas.abdielaldana.com/" + row.ruta_despues}
                                                                style={{ height: '100%', width: '100%', objectFit: "cover" }}
                                                            />
                                                        </Link>
                                                    </View>
                                                    <View style={{ width: "70%", textAlign: "left", marginLeft: "25px" }}>
                                                        <View>
                                                            <Text style={{ color: "#094b88", fontSize: "13px" }}>Despues</Text>
                                                            <View style={styles.divider}></View>
                                                            <View>
                                                                <Text style={{ fontSize: '12px' }}>{row.descripcion_despues}</Text>
                                                            </View>
                                                        </View>

                                                    </View>
                                                </View>
                                            </View>
                                        </View>
                                    </React.Fragment>
                                )
                            })}
                        </View>
                    </View>
                }

                <View fixed style={{ marginTop: "auto", width: "100%", borderTopColor: "gray", borderTopWidth: "1px" }}>
                    <Text style={{ textAlign: "center", marginTop: "5px", fontSize: "10px" }}>
                        Dante Portillo Maldonado
                    </Text>
                </View>
                <View fixed style={[styles.section, { display: "flex", borderTopColor: "gray", borderTopWidth: "1px", flexDirection: "row", justifyContent: "space-evenly", alignItems: "flex-start", fontSize: "8px" }]}>
                    <View style={{ width: "90%" }}>
                        <Text style={{ textAlign: "center", marginTop: "10px" }}>
                            Calle: Miguel Nieto #2503 Colonia Industial, Monterrey, N.L.
                        </Text>                        
                        <Link src={'mailto:dante.portillo@gmail.com?subject=Sobre la Cotizacion ' + base.ot} style={{ textAlign: "center", marginTop: "10px" }}>
                            dante.portillo@gmail.com
                        </Link>
                    </View>
                </View>

                <Text
                    style={styles.footer}
                    render={({ pageNumber, totalPages }) => `Página ${pageNumber} de ${totalPages}`}
                    fixed
                />

            </Page>

        </Document>
    );
}

